import { Interpolation, Theme } from "@emotion/react";
import Markdown from "react-markdown";
import rehypeExternalLinks from "rehype-external-links";
import rehypeRaw from "rehype-raw";

import { markdown } from "./MarkdownContent.module.css";

type MarkdownContentProps = {
  /**
   * A string containing Markdown
   */
  body: string;
  /**
   * Optional prop containing an object with CSS styles
   */
  css?: Interpolation<Theme>;
  /**
   * Optional prop containing a test ID
   *
   * @default "markdown-content"
   */
  testId?: string;
};

export function MarkdownContent(props: MarkdownContentProps) {
  const { body, css, testId = "markdown-content" } = props;
  return (
    <div css={css} data-testid={testId}>
      <Markdown
        rehypePlugins={[rehypeRaw, [rehypeExternalLinks, { target: "_blank" }]]}
        className={markdown}
      >
        {body}
      </Markdown>
    </div>
  );
}
